import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { ColoredCircularProgress } from '../../../../../../components/UI/Typography';
import { Constants } from '../../../../../../constants/redeProto';
import { protoColors } from '../../theme/tokens';

interface StateFeedbackProps {
  loading: boolean;
  error: boolean;
  empty?: boolean;
  children: ReactNode;
}

const wrapperSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  minHeight: '240px',
  color: protoColors.textMuted,
};

export function StateFeedback({
  loading,
  error,
  empty,
  children,
}: StateFeedbackProps): JSX.Element {
  if (loading) {
    return (
      <Box sx={wrapperSx}>
        <ColoredCircularProgress />
        <Typography>{Constants.loading}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={wrapperSx}>
        <Typography sx={{ color: protoColors.danger }}>
          {Constants.error}
        </Typography>
      </Box>
    );
  }

  if (empty) {
    return (
      <Box sx={wrapperSx}>
        <Typography>{Constants.empty}</Typography>
      </Box>
    );
  }

  return <Box>{children}</Box>;
}
